import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { GetReportsResponseDto } from "../../model/reports/dto/GetReportsResponseDto";

const reportState = (state: RootState) => state.report;

const selectReport = createSelector(
  reportState,
  (state) => (state.report || {}) as GetReportsResponseDto,
);

const selectHasReport = createSelector(reportState, (state) =>
  Boolean(state.report),
);

const selectReportLoading = createSelector(
  reportState,
  (state) => state.reportLoading,
);

export const reportSliceSelectors = {
  selectReport,
  selectHasReport,
  selectReportLoading,
};
